const plates = {
  ABJ: "Abaji Area Council",
  ABC: "Abuja Municipal Area Council",
  BWR: "Bwari",
  GWA: "Gwagwalada",
  KUJ: "Kuje Area Council",
  KWL: "Kwali",
  RSH: "Karshi",
  RBC: "Rubuchi",
  YAB: "Yaba",
}

module.exports = plates
